/**
 * Single source of truth for YouTube video metadata.
 * Keyed by YouTube video ID. Used for VideoObject structured data
 * and thumbnail alt text so static HTML matches what each page renders.
 */
export interface VideoMeta {
  name: string;
  uploadDate: string;
}

export const VIDEOS: Record<string, VideoMeta> = {
  "-8-f3fV09Lw": {
    name: "Large Engineered Retaining Wall Installation in Hackensack, NJ | Masonry Pro Construction",
    uploadDate: "2026-01-07T20:58:02-08:00",
  },
  "0Kid2ea7tik": {
    name: "Stone Veneer Installation in Oakland, NJ by Masonry Pro Construction - Mason Contractor",
    uploadDate: "2026-01-09T14:00:01-08:00",
  },
  "0RG6pVGG92E": {
    name: "Paver Patio with Outdoor Kitchen Installation in North Haledon, NJ by Masonry Pro Construction",
    uploadDate: "2026-01-09T09:00:02-08:00",
  },
  "48t7raf6QiE": {
    name: "Retaining Wall, Steps & Paver Walkway Installation in Bergen County, NJ by Masonry Pro Construction",
    uploadDate: "2026-01-08T20:29:31-08:00",
  },
  "50WpbxLOZa8": {
    name: "Paver Driveway Installation in Oakland, NJ by Masonry Pro Construction",
    uploadDate: "2026-01-08T21:12:32-08:00",
  },
  "7N5f77AabdU": {
    name: "Custom Brick Pizza Oven & Outdoor Kitchen in Totowa, NJ | Masonry Pro Construction",
    uploadDate: "2026-01-07T21:08:33-08:00",
  },
  "_8_1uw8ZHAk": {
    name: "Paver Patio Installation in Verona, NJ by Masonry Pro Construction",
    uploadDate: "2026-01-09T00:16:17-08:00",
  },
  "aJJQS6FX--0": {
    name: "Retaining Wall & Paver Driveway Installation in Kinnelon, NJ by Masonry Pro Construction #shorts",
    uploadDate: "2026-01-08T20:16:15-08:00",
  },
  "awvHabWeQFw": {
    name: "Paver Patio Installation in Clifton, NJ by Masonry Pro Construction",
    uploadDate: "2026-01-09T13:00:01-08:00",
  },
  "bcQ5eroM02M": {
    name: "New Paver Patio And Pool Installed In Bloomfeild NJ by Masonry Pro Construction #paverpatio",
    uploadDate: "2026-04-10T05:51:20-07:00",
  },
  "BiS2ELaDD0E": {
    name: "Retaining Wall Installation in New Jersey - Completed by Masonry Pro  Construction #retainingwall",
    uploadDate: "2026-01-06T19:17:38-08:00",
  },
  "c_50pnhg30w": {
    name: "Paver Walkway, Masonry Steps & Stone Veneer Installation in Wayne, NJ by Masonry Pro Construction",
    uploadDate: "2026-01-08T20:20:41-08:00",
  },
  "cFHz4fwoL34": {
    name: "Retaining Wall Installation in Essex County, NJ by Masonry Pro Construction - Mason Contractor",
    uploadDate: "2026-01-09T11:00:45-08:00",
  },
  "Fogsfyz7P18": {
    name: "Paver Patio with Outdoor Kitchen & Fire Pit in North Caldwell NJ - Masonry Pro Construction",
    uploadDate: "2026-01-06T19:26:01-08:00",
  },
  "FwwKcMlYRRU": {
    name: "Old Deck to Paver Patio & New Deck Transformation in Pompton Plains, NJ by Masonry Pro Construction",
    uploadDate: "2026-01-07T21:32:52-08:00",
  },
  "g25VA4vng-Y": {
    name: "New Cambridge Block Retaining Wall in Nutley, NJ | Masonry Pro Construction",
    uploadDate: "2026-01-07T21:11:48-08:00",
  },
  "G_i-bncb70U": {
    name: "Paver Patio with Fire Pit in Clifton, NJ | Installed By Masonry Pro Construction",
    uploadDate: "2026-01-07T20:52:25-08:00",
  },
  "hMO7o0DWqAw": {
    name: "New Retaining Wall & Stone Veneer Steps in Clifton NJ - Masonry Pro Construction",
    uploadDate: "2026-01-17T16:59:24-08:00",
  },
  "IaLfa_u0pFQ": {
    name: "Paver Patio Installation in Bloomfield NJ - Completed by Masonry Pro  Construction #outdoorliving",
    uploadDate: "2026-01-06T19:04:33-08:00",
  },
  "KFgLmBVqRZQ": {
    name: "Paver Patio, Outdoor Kitchen & Fireplace Installation in Essex County, NJ - Masonry Pro Construction",
    uploadDate: "2026-01-09T15:00:29-08:00",
  },
  "KjTHv1gQP9c": {
    name: "Paver Patio with Fire Pit Installation in Clifton, NJ by Masonry Pro Construction",
    uploadDate: "2026-01-08T21:10:07-08:00",
  },
  "ktQRtcBf70o": {
    name: "Before & After: New Retaining Wall Installation in Morris County, NJ by Masonry Pro Construction",
    uploadDate: "2026-01-08T20:37:00-08:00",
  },
  "L6zFeqCTTSI": {
    name: "Paver Patio Installation in Totowa, NJ by Masonry Pro Construction",
    uploadDate: "2026-01-08T21:07:03-08:00",
  },
  "M16CRt8dmJ4": {
    name: "Pool Paver Patio, Outdoor Kitchen & Fire Pit Installation in Wayne, NJ by Masonry Pro Construction",
    uploadDate: "2026-01-09T10:00:26-08:00",
  },
  "MOXQjyMxrD8": {
    name: "Block Retaining Wall Installation in Roseland, NJ by Masonry Pro Construction - Expert Contractor",
    uploadDate: "2026-01-08T20:26:40-08:00",
  },
  "p_RCDyOyCgU": {
    name: "Paver Patio Installation in Bergen County, NJ by Masonry Pro Construction",
    uploadDate: "2026-01-08T20:34:02-08:00",
  },
  "plh-ZGZz65A": {
    name: "Paver Patio & Fire Pit Installation in North Haledon, NJ by Masonry Pro Construction",
    uploadDate: "2026-01-08T20:48:52-08:00",
  },
  "Po36ZvNh7ro": {
    name: "Paver Patio Installation in Livingston, NJ by Masonry Pro Construction - Masonry Contractor",
    uploadDate: "2026-01-07T21:36:39-08:00",
  },
  "qBJO5fKXbPI": {
    name: "New Paver Patio Installed in Woodland Park NJ - Masonry Pro Construction",
    uploadDate: "2026-01-17T17:08:40-08:00",
  },
  "QMzipttnOXM": {
    name: "Paver Patio Installation Contractor Essex County NJ - Masonry Pro Construction",
    uploadDate: "2026-01-09T16:00:26-08:00",
  },
  "rqWp1V0r8sY": {
    name: "New Steps, Paver Walkway & Retaining Wall installed In Essex County, NJ | Masonry Pro Construction",
    uploadDate: "2026-01-07T12:02:29-08:00",
  },
  "sbUEKc_QU78": {
    name: "Custom Paver Patio, Steps & Outdoor Kitchen Build in North Haledon, NJ | Masonry Pro Construction",
    uploadDate: "2026-01-09T12:00:52-08:00",
  },
  "t2rG1WND0ug": {
    name: "Stone Veneer Installation in Wayne, NJ by Masonry Pro Construction - Expert Mason Contractor",
    uploadDate: "2026-01-07T21:20:55-08:00",
  },
  "TspgYEFQ_sQ": {
    name: "Paver Patio and Fire Pit Installation in Pine Brook, NJ by Masonry Pro Construction",
    uploadDate: "2026-01-07T21:24:43-08:00",
  },
  "uPmPXH1Vm4s": {
    name: "Retaining Wall, Paver Walkway, Steps & Concrete Sidewalks in Nutley, NJ by Masonry Pro Construction",
    uploadDate: "2026-01-08T21:35:27-08:00",
  },
  "w9nUyl2SgLU": {
    name: "Stunning Retaining Wall Installation in Passaic County, NJ | Masonry Pro Construction",
    uploadDate: "2026-01-07T20:48:29-08:00",
  },
  "xSJR_H3armE": {
    name: "Paver Driveway & Paver Walkway Installation in Cedar Grove, NJ by Masonry Pro Construction",
    uploadDate: "2026-01-08T20:52:10-08:00",
  },
  "YBv-bvrkguI": {
    name: "New Retaining Wall & Concrete Sidewalks Installation in Nutley, NJ | Masonry Pro Construction",
    uploadDate: "2026-01-07T21:00:29-08:00",
  },
  "Z1lcOlPIbWI": {
    name: "Beautiful Paver Walkway & Block Steps Installed in North Caldwell, NJ | By Masonry Pro Construction",
    uploadDate: "2026-01-07T11:54:00-08:00",
  },
"J8_3EVFMsvM": {
    name: "Stunning Retaining Wall Installation in Totowa, NJ | Masonry Pro Construction",
    uploadDate: "2026-01-07T21:14:41-08:00",
  },
  "RTdf5C02SHY": {
    name: "Retaining Wall Installation in Wayne, NJ by Masonry Pro Construction",
    uploadDate: "2026-01-08T21:15:41-08:00",
  },
  "-G1xdMCcks0": {
    name: "Retaining Wall Installation in Bergen County, NJ by Masonry Pro Construction",
    uploadDate: "2026-01-08T21:04:02-08:00",
  },
  "FR50G7k4qDU": {
    name: "Retaining Wall Installation in Cedar Grove, NJ by Masonry Pro Construction - Mason Contractor",
    uploadDate: "2026-01-08T21:00:33-08:00",
  },
};

export function getVideoMeta(id: string): VideoMeta {
  return VIDEOS[id] ?? { name: "Masonry Pro Construction Project Video", uploadDate: "2026-01-08T00:00:00-08:00" };
}
